import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=cf05fb68&scoped=true&"
import script from "./AlertBar.vue?vue&type=script&lang=js&"
export * from "./AlertBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf05fb68",
  null
  
)

export default component.exports